import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { CONFIG } from "@/config";
import { formatApiError } from "@/hooks/useAdmin";

const FIELD = "w-full rounded-xl border border-white/15 bg-white/[0.06] px-4 py-3 text-[15px] text-white placeholder:text-white/40 outline-none focus:border-gold focus:ring-2 focus:ring-gold/40";
const LABEL = "mb-1.5 block text-xs font-semibold uppercase tracking-wide text-white/60";

export const LoginView = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Login failed. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5">
      <div className="grain absolute inset-0" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-sm"
      >
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-xs font-semibold text-white/60 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Back to site
        </Link>
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold/15 text-gold"><Lock className="h-5 w-5" /></span>
          <div>
            <h1 className="font-display text-xl font-bold text-white">Auxieron CRM</h1>
            <p className="text-sm text-white/50">{CONFIG.brand} admin access</p>
          </div>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className={LABEL} htmlFor="a-email">Email</label>
            <input id="a-email" data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={FIELD} placeholder="admin@auxieron.com" />
          </div>
          <div>
            <label className={LABEL} htmlFor="a-pass">Password</label>
            <input id="a-pass" data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={FIELD} placeholder="••••••••" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-300">{error}</p>}
          <button
            type="submit" data-testid="admin-login-submit" disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-[15px] font-bold text-navy transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-[#ffc41f] disabled:opacity-70"
          >
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};
